import * as ActionTypes from 'actions';
import Calendar from 'lib/Calendar';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  pages: [],
  page_details: {},
  page_events: [],
  page_metadata: {},
  isLoading: false,
  response: {},
  search: '',
};

export default function(state = initialState, action = {}) {
  const { type, response, id, error, payload, search } = action;
  const { byId } = state;

  switch (type) {
  case ActionTypes.PAGE_LIST_REQUEST:
    return Object.assign({}, state, { pages: [], isLoading: true });

  case ActionTypes.PAGE_LIST_SUCCESS: {
    const pages = response.data.length ? response.data : {};

    return Object.assign({}, state, { pages: pages, response, isLoading: false });
  }

  case ActionTypes.PAGE_LIST_FAILURE:
    console.error('Error loading pages', error);

    return Object.assign({}, state, { response, isLoading: false });

  case ActionTypes.SET_PAGE_LIST_SEARCH:
    return Object.assign({}, state, { search });

  case ActionTypes.PAGE_VIEW_REQUEST:
    return Object.assign({}, state, { page_details: {}, page_events: [], page_metadata: {}, isLoading: true });

  case ActionTypes.PAGE_VIEW_SUCCESS: {
    const page_details = response.report ? response.report : {};
    const page_metadata = response.metadata ? response.metadata : {};
    const massagedEvents = response.events.map((event) => {
      const massaged = Calendar.massageEvent(event);
      return massaged;
    });

    return Object.assign({}, state, { page_details: page_details, page_events: massagedEvents, page_metadata: page_metadata, response, isLoading: false });
  }

  case ActionTypes.PAGE_VIEW_FAILURE: {
    console.error('Error loading event', id, error);

    return Object.assign({}, state, { response, isLoading: false });
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/page.js